import {
  isPostingMetric,
  isScreenerMetric,
  isSentimentMetric,
  type MetricValues,
} from '../../PageConfigProvider/types/metric';

type MetricGroup =
  | 'TD'
  | 'TRANSITION'
  | 'SCREENER'
  | 'SCREENER_COMPATIBLE'
  | 'OTHER';

const getMetricGroup = (value: string): MetricGroup => {
  if (value === 'td_users') return 'TD';
  if (
    value === 'transitions_inflow' ||
    value === 'transitions_outflow' ||
    value === 'transitions_inflows_and_outflows' ||
    value === 'transitions_netflow'
  ) {
    return 'TRANSITION';
  }
  if (isScreenerMetric(value as MetricValues) || value === 'market_share') {
    return 'SCREENER';
  }
  if (
    isSentimentMetric(value as MetricValues) ||
    isPostingMetric(value as MetricValues)
  ) {
    return 'SCREENER_COMPATIBLE';
  }
  return 'OTHER';
};

const isScreenerCompatible = (value: string): boolean => {
  const metric = value as MetricValues;
  return (
    isScreenerMetric(metric) ||
    isSentimentMetric(metric) ||
    isPostingMetric(metric) ||
    value === 'market_share'
  );
};

const deriveDominantGroup = (
  selected: ReadonlyArray<string>
): MetricGroup | undefined => {
  if (!selected || selected.length === 0) return undefined;
  const lastGroup = getMetricGroup(selected?.[selected.length - 1] ?? '');
  if (lastGroup === 'SCREENER_COMPATIBLE') return 'SCREENER';
  return lastGroup;
};

export const filterEffectiveMetrics = (
  selected: ReadonlyArray<string>
): MetricValues[] => {
  const dominant = deriveDominantGroup(selected);
  if (!dominant) return selected as MetricValues[];

  if (dominant === 'TD') {
    return ['td_users'] as MetricValues[];
  }

  if (dominant === 'TRANSITION') {
    return selected.filter(
      (v) => getMetricGroup(v) === 'TRANSITION'
    ) as MetricValues[];
  }

  if (dominant === 'SCREENER') {
    return selected.filter((v) => isScreenerCompatible(v)) as MetricValues[];
  }

  return selected.filter(
    (v) => getMetricGroup(v) === 'OTHER'
  ) as MetricValues[];
};
